import React from "react";

import PropTypes from "prop-types";

import { ReactComponent as IconDownload18 } from "../../icons/icon/18/a-icon-download-18.svg";

import "./fileDownload.scss";

const FileDownload = ({
  fileIcon,
  href,
  image = null,
  size,
  title,
}) => (
  <a href={href} target="_blank" rel="noopener noreferrer" download className="file-download no-style">
    {image && (
      <div className="file-download__image">
        {image}
      </div>
    )}
    <div className="file-download__content">
      <span className="file-download__file-icon">{fileIcon}</span>
      <div className="flex-fill">
        <div className="typo-label">
          {title}
        </div>
        {size && (
          <div className="typo-small-label">
            ({size})
          </div>
        )}
      </div>
      <span className="file-download__download-icon">
        <IconDownload18 />
      </span>
    </div>
  </a>
);

FileDownload.propTypes = {
  fileIcon: PropTypes.oneOfType([PropTypes.object]).isRequired,
  href: PropTypes.string.isRequired,
  image: PropTypes.node,
  size: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default FileDownload;
